import { render, staticRenderFns } from "./BrandItem.vue?vue&type=template&id=6e609006&scoped=true"
import script from "./BrandItem.vue?vue&type=script&lang=js"
export * from "./BrandItem.vue?vue&type=script&lang=js"
import style0 from "./BrandItem.vue?vue&type=style&index=0&id=6e609006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e609006",
  null
  
)

export default component.exports